import React from 'react';
import PropTypes from 'prop-types';

import QuestionAnswerDropdownActions from 'containers/QuestionnairePage/GenericQuestion/QuestionAnswerDropdownActions';
import { QA_SUPPORTED_ACTIONS } from 'containers/QuestionnairePage/GenericQuestion/QuestionAnswerDropdownActions/constants';
import { calculateDropdownProps } from 'containers/QuestionnairePage/GenericQuestion/utils';
import { EDIT_PERMISSIONS } from 'containers/Permissions';
import questionnaireMessages from 'containers/QuestionnairePage/messages';

function AttributeActions({
  moveDownDisabled,
  moveUpDisabled,
  removeDisabled,
  onMoveDown,
  onMoveUp,
  onRemove,
  addMedia,
  removeMedia,
  uploadUrl,
  media,
  permissions = [],
  canHaveMoreThanOneAttribute = true,
  isMaxDiff = false,
  index = 0,
  refId,
  surveyId,
}) {
  const [hasReOrderPermission, hasRemovePermission, hasEditMediaPermission] =
    permissions;

  const uploadMediaPermission =
    !canHaveMoreThanOneAttribute && !isMaxDiff
      ? EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_EDIT_MEDIA
      : EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_EDIT_MEDIA;

  const dropdownProps = calculateDropdownProps({
    canModifyMedia: true,
    reorderAnswerDownDisabled: moveDownDisabled,
    reorderAnswerUpDisabled: moveUpDisabled,
    permissions: {
      [EDIT_PERMISSIONS.ANSWER_REORDER]: hasReOrderPermission,
      [EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_EDIT_MEDIA]: hasEditMediaPermission,
      [EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_EDIT_MEDIA]:
        hasEditMediaPermission,
    },
    uploadMediaPermission,
  });
  const settingsTooltipMessage = questionnaireMessages.attributeSettings;

  if (!canHaveMoreThanOneAttribute && isMaxDiff) {
    return (
      <QuestionAnswerDropdownActions
        index={index}
        refId={refId}
        surveyId={surveyId}
        supportedActions={QA_SUPPORTED_ACTIONS.MAXDIFF_ATTRIBUTE}
        uploadUrl={uploadUrl}
        media={media}
        onAddMedia={addMedia}
        onRemoveMedia={removeMedia}
        canModifyMedia
        settingsTooltipMessage={settingsTooltipMessage}
        {...dropdownProps}
      />
    );
  }

  if (!canHaveMoreThanOneAttribute) {
    return (
      <QuestionAnswerDropdownActions
        index={index}
        refId={refId}
        surveyId={surveyId}
        supportedActions={QA_SUPPORTED_ACTIONS.CONJOINT_LEVEL}
        uploadUrl={uploadUrl}
        media={media}
        onAddMedia={addMedia}
        onRemoveMedia={removeMedia}
        canModifyMedia
        canReorder
        canReorderAnswerUp={dropdownProps.canReorderAnswerUp}
        canReorderAnswerDown={dropdownProps.canReorderAnswerDown}
        reorderAnswerUp={onMoveUp}
        reorderAnswerDown={onMoveDown}
        onRemoveNode={onRemove}
        canShowRemove={Boolean(onRemove)}
        removeNodeDisabled={removeDisabled || !hasRemovePermission}
        {...dropdownProps}
      />
    );
  }

  return (
    <div className="flex flex-justify-center flex-align-items--center question-answer-actions">
      <QuestionAnswerDropdownActions
        index={index}
        refId={refId}
        surveyId={surveyId}
        supportedActions={QA_SUPPORTED_ACTIONS.CONJOINT_ATTRIBUTE}
        uploadUrl={uploadUrl}
        media={media}
        onAddMedia={addMedia}
        onRemoveMedia={removeMedia}
        canModifyMedia
        canReorder={canHaveMoreThanOneAttribute}
        canReorderAnswerUp={dropdownProps.canReorderAnswerUp}
        canReorderAnswerDown={dropdownProps.canReorderAnswerDown}
        reorderAnswerUp={onMoveUp}
        reorderAnswerDown={onMoveDown}
        onRemoveNode={onRemove}
        canShowRemove={Boolean(onRemove)}
        removeNodeDisabled={removeDisabled || !hasRemovePermission}
        settingsTooltipMessage={settingsTooltipMessage}
        {...dropdownProps}
      />
    </div>
  );
}

AttributeActions.propTypes = {
  moveUpDisabled: PropTypes.bool,
  moveDownDisabled: PropTypes.bool,
  removeDisabled: PropTypes.bool,
  onMoveDown: PropTypes.func,
  onMoveUp: PropTypes.func,
  onRemove: PropTypes.func,
  permissions: PropTypes.array,
  addMedia: PropTypes.func,
  removeMedia: PropTypes.func,
  uploadUrl: PropTypes.string,
  media: PropTypes.object,
  canHaveMoreThanOneAttribute: PropTypes.bool,
  isMaxDiff: PropTypes.bool,
  index: PropTypes.number,
  refId: PropTypes.string,
  surveyId: PropTypes.number,
};

export default AttributeActions;
